/**
 * @generated SignedSource<<fd5cc684241155968b8f4b41bbb86f5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrganizationGuestListActionDropdownFragment$data = {
  readonly email: string | null;
  readonly id: string;
  readonly user: {
    readonly fullName: string;
    readonly id: string;
  };
  readonly " $fragmentType": "OrganizationGuestListActionDropdownFragment";
};
export type OrganizationGuestListActionDropdownFragment$key = {
  readonly " $data"?: OrganizationGuestListActionDropdownFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationGuestListActionDropdownFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrganizationGuestListActionDropdownFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuestMembership",
  "abstractKey": null
};
})();

(node as any).hash = "85a244865d03a32b2e741c60d2e6ea62";

export default node;
